module.exports = __webpack_public_path__ + "static/media/c1-empt.9c05ce17.svg";